import { ToggleProps } from 'shared/ui/toggle/toggle.type';
import cls from './toggle.module.scss';
import { Field, Label, Switch } from '@headlessui/react';

export const Toggle = ({
  label,
  isEnabled,
  setIsEnabled,
  heading,
}: ToggleProps) => {
  return (
    <Field className={cls.toggleContainer}>
      {heading ? (
        <div className={cls.toggleHeading}>
          <h2>{heading}</h2>
          <span>{label}</span>
        </div>
      ) : (
        <Label as='p'>{label}</Label>
      )}

      <Switch
        checked={isEnabled}
        onChange={setIsEnabled}
        className={`${cls.toggle} ${isEnabled ? cls.enabled : ''}`}
      >
        <div className={`${cls.thumb} ${isEnabled ? cls.enabled : ''}`} />
      </Switch>
    </Field>
  );
};
